import axios from 'axios'
const instance = axios.create({
    baseURL: 'http://124.70.140.77:8081',
    //baseURL: 'http://192.168.0.102:8081',
    //baseURL: 'http://172.20.10.10:7086/',
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
        "uid": localStorage.getItem("uid"),
        "rid": localStorage.getItem("rid"),
    }
});

instance.interceptors.request.use(function(config) {
    return config;
}, function(error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    return Promise.reject(error);
});

export default instance;